import React from "react";
import Reveal from "./Reveal";
import { IMAGES, SKILLS } from "../../data/content";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section-pad relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <Reveal className="lg:col-span-5">
          <div className="overline mb-4">About Me</div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight mb-10">
            Who
            <br />I Am.
          </h2>
          <div className="relative overflow-hidden rounded-xl border border-white/10">
            <img src={IMAGES.portrait} alt="Amiran Azaladze" className="w-full h-[420px] object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/60 to-transparent" />
          </div>
        </Reveal>

        <div className="lg:col-span-7 lg:pt-16">
          <Reveal>
            <p className="text-ink-secondary text-lg leading-relaxed mb-6">
              I'm Amiran Azaladze — an entrepreneur and business leader with over a decade of experience founding,
              scaling, and investing in companies across global markets.
            </p>
            <p className="text-ink-secondary text-lg leading-relaxed mb-6">
              My approach is rooted in a deep respect for people, markets, and the long game. Every venture begins with
              a clear problem worth solving — and a relentless focus on building teams and systems that last.
            </p>
            <p className="text-ink-secondary text-lg leading-relaxed">
              I believe great businesses don't shout. They earn trust quietly, deliver consistent value, and leave a
              lasting mark on the people and communities they serve.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="mt-10 flex flex-wrap gap-3">
            {SKILLS.map((skill) => (
              <span
                key={skill}
                className="rounded-full border border-white/10 px-4 py-2 text-sm text-ink-secondary hover:border-amber/50 hover:text-ink transition-colors duration-300"
              >
                {skill}
              </span>
            ))}
          </Reveal>

          <Reveal delay={0.25} className="mt-12 grid grid-cols-2 gap-8 max-w-md">
            <div>
              <div className="font-display font-bold text-4xl text-amber">12+</div>
              <div className="text-sm text-ink-muted mt-1 uppercase tracking-[0.14em]">Years of Business</div>
            </div>
            <div>
              <div className="font-display font-bold text-4xl text-amber">8</div>
              <div className="text-sm text-ink-muted mt-1 uppercase tracking-[0.14em]">Ventures Built</div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
